import * as React from "react";
import {
  LiveStreamingCard,
  Loading,
  NavBar,
  NewFooter,
  Text,
} from "../components";
import { Routes, Route, useLocation } from "react-router-dom";
import { isLiveStreamingDate } from "../utils/function";
import { usePageContextState } from "../context/PageContext";
import {
  FormRegistration,
  InfoLombaPage,
  JadwalPertandinganPage,
  KlasemenPertandinganPage,
  LokasiPage,
  Registration,
  FormAddPlayer,
  ReaderDetailPage,
} from "../pages";
import dataMenu from "../data/menu";
import Home from "../pages/v2/Home";
import HomeSoc from "../pages/v2/HomeSoc";
import HomePressCon from "../pages/v2/HomePressCon";
import HomeDetail from "../pages/v2/HomeDetails";
import { useEffect, useMemo } from "react";
import useWindowSize from "../hooks/useWindowSize";
import { AppContainer } from "../styles/BaseStyled.styled";
import {
  useFetchEventSeries,
  useFetchGetCurrentEvent,
  usePostTokenLiveScore,
} from "../networks";
import moment from "moment";
import { func } from "../utils";
import audio from "../assets/audio/sample-12s.mp3";
import ReactHowler from "react-howler";
import NavBarBreadCrumb from "../components/atoms/NavBarBreadCrumb";
import Login from "../pages/v2/Login";
import RegistrationSuccess from "../components/molecules/v2/RegistrationSuccess";
import HomeUser from "../pages/v2/HomeUser/HomeUser";
import { useUserData } from "../store/user";
import FormPayment from "../pages/v2/FormPayment/FormPayment";
import PaymentSuccess from "../components/molecules/v2/PaymentSuccess";
import KlasemenPertandinganSocPage from "../pages/v2/KlasemenPertandinganSoc";
import GalleryDetail from "../pages/v2/GalleryDetail/GalleryDetail";
import JadwalPertandinganSocPage from "../pages/v2/JadwalPertandinganSoc/JadwalPertandinganSoc";
import FaseKnockoutSOC from "../pages/v2/FaseKnockoutSoC";
import { tokenKey } from "../utils/httpRequest";
import Rsvp from "../pages/v2/Rsvp";
import FormRegistrationDance from "../pages/v2/FormRegistrationDance";

const PageRoutes = () => {
  const { city, pageMode, activeColor, idInView } = usePageContextState();
  const { pathname } = useLocation();
  const { size } = useWindowSize();
  const [nearbyEvent, setNearbyEvent] = React.useState(null);
  const { accessToken } = useUserData();
  const isMobileView = (size?.width || 0) <= 768;
  const isLogin = !!accessToken;

  const { data: dataEventRaw, isFetching: fetchingEventSeries } =
    useFetchEventSeries();

  const { getCurrentEvent, isLoading } = useFetchGetCurrentEvent();
  const { mutateAsync: requestTokenLiveScore } = usePostTokenLiveScore();

  const dataEventSeries = dataEventRaw?.data?.data?.eventSeries ?? [];
  const dataMainRegion = React.useMemo(() => {
    if (!dataEventSeries) return {};
    return dataEventSeries?.map((data, idx) => ({
      id: idx,
      title: data?.main_region_name,
      slug: data?.slug,
    }));
  }, [dataEventSeries]);

  const getCurrentEventCity = React.useCallback(async () => {
    try {
      const dataSlug = await dataMainRegion?.map((data) => data?.slug);
      const currentEvent = await getCurrentEvent(dataSlug);
      const nearbyEventTime = currentEvent?.map((children) => {
        return children?.region_series.find((val) => {
          //returns only the first object found
          const { event_start_date, event_end_date } = val;
          // const currentDate = moment("2024-02-29"); //subang sample
          const currentDate = moment();
          const startDate = moment(event_start_date);
          const endDate = moment(event_end_date);
          // const diffFromStart = startDate?.diff(currentDate, "minute");
          // const diffFromEnd = currentDate?.diff(endDate, "minute");
          // return diffFromStart <= 0 && diffFromEnd <= 0;
          return (
            currentDate.isSameOrAfter(startDate, "day") &&
            currentDate.isSameOrBefore(endDate, "day")
          );
        });
      });
      setNearbyEvent(nearbyEventTime?.find((val) => val));
    } catch (error) {
      console.log(error);
    }
  }, [dataMainRegion]);

  React.useEffect(() => {
    getCurrentEventCity();
  }, [dataMainRegion]);

  const handleTokenLiveScore = React.useCallback(async () => {
    try {
      const tokenData = await requestTokenLiveScore();

      if (tokenData) {
        const tokenValue = tokenData?.data?.data?.id_token;
        localStorage.setItem(tokenKey, tokenValue);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    handleTokenLiveScore();
  }, [handleTokenLiveScore]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const currentCity = useMemo(() => {
    return city;
  }, [city]);

  //ORIGIN
  // const homeProperties = isLogin
  // ? { path: "/", element: <HomeUser slug={{ city: "makassar" }} /> }
  // : nearbyEvent
  // ? nearbyEvent?.slug === "soc"
  //   ? { path: "/", element: <HomeSoc /> }
  //   : {
  //       path: "/",
  //       element: <HomeDetail slug={{ city: nearbyEvent?.slug }} />,
  //     }
  // : {
  //     path: "/",
  //     element: nearbyEvent === undefined ? <HomePressCon /> : <></>,
  //   }; //since nearbyEvent is null when fetching data from api and undefined when no data found

  const homeProperties = isLogin
    ? { path: "/", element: <HomeUser slug={{ city: "makassar" }} /> }
    : { path: "/", element: <HomePressCon /> };

  const isLandingPage = !city && (pathname === "/" || pathname === "/main");
  const isPressCon = city === "press-con" || city;
  const isRegistrationPage = pathname?.includes("registrasi");
  const whitelistNavbar = pathname === "/" || pathname.includes("/pembayaran");
  const isAbsoluteHide = pathname.includes("/rsvp") && !isMobileView;
  const isJadwalOrKlasemen =
    pathname?.includes("jadwal-pertandingan") ||
    pathname?.includes("pertandingan");
  const pageNavbar =
    whitelistNavbar && isLogin
      ? "registered-user"
      : isLandingPage
      ? "landing-page"
      : isPressCon
      ? "press-con"
      : "";
  const isHideAllMenu = pathname?.includes("/gallery");
  // const isOnSocPath = window.location.pathname.startsWith("/soc");
  const isOnSocPath = true;
  return (
    <AppContainer
      bgColor={activeColor}
      bgRepeat={isMobileView ? "repeat" : "no-repeat"}
      bgSize={
        isMobileView
          ? ["jadwal-pertandingan", "klasemen-pertandingan"]?.includes(idInView)
            ? "auto"
            : "100vh"
          : "center"
      }
      id="appContainer"
    >
      {isAbsoluteHide ? null : whitelistNavbar &&
        isLogin &&
        !isMobileView ? null : !isRegistrationPage ? (
        <NavBar
          menus={isHideAllMenu ? [] : dataMenu(currentCity, pageNavbar)}
          pageType={pageNavbar}
          isShowBurger={isMobileView}
        />
      ) : (
        <NavBarBreadCrumb
          className={"bg-[#FFFF] z-20"}
          menus={dataMenu(currentCity, pageNavbar)}
          pageType={pageNavbar}
          isShowBurger={isMobileView}
        />
      )}

      {/* <ReactHowler src={audio} playing={true} loop /> */}
      {isLoading && <Loading />}
      <Routes>
        <Route path={homeProperties?.path} element={homeProperties?.element} />
        {/* <Route path={"/"} element={<HomeSoc />} /> */}
        {/* <Route path={"/"} element={<HomePressCon />} /> */}
        <Route path={"/main"} element={<HomePressCon />} />
        {/* <Route path={"/soc"} element={<HomeSoc />} /> */}
        {/* <Route path={"/:city"} element={<HomePage />} /> */}
        <Route path={"/:city"} element={<HomeDetail />} />
        <Route
          path={"/:city/jadwal-pertandingan"}
          element={<JadwalPertandinganPage />}
        />
        <Route
          path={"/:city/klasemen-pertandingan"}
          element={<KlasemenPertandinganPage />}
        />
        <Route path={"/:city/info-lokasi"} element={<LokasiPage />} />
        <Route path={"/:city/info-lomba"} element={<InfoLombaPage />} />

        <Route
          path={"/:city/reader-detail/:slug/:title/:contentType"}
          element={<ReaderDetailPage />}
        />

        <Route path={"/:city/registrasi"} element={<Registration />} />
        <Route path={"/registrasi"} element={<Registration />} />
        <Route
          path={"/:city/registrasi/form/:category/:region_id/:category_id"}
          element={<FormRegistration />}
        />
        <Route
          path={
            "/:city/registrasi/form/:category/:region_id/:category_id/:mode"
          }
          element={<FormRegistration />}
        />
        <Route
          path={
            "/:city/registrasi/form-dance/:category/:region_id/:category_id"
          }
          element={<FormRegistrationDance />}
        />
        <Route
          path={
            "/:city/registrasi/form-dance/:category/:region_id/:category_id/:mode"
          }
          element={<FormRegistrationDance />}
        />
        <Route
          path={"/:city/registrasi/add-player/:category/:event_registration_id"}
          element={<FormAddPlayer />}
        />
        <Route path={"/login"} element={<Login />} />
        {/* <Route path={"/gallery"} element={<GalleryDetail />} /> */}
        <Route
          path={"/:city/registrasi-success/"}
          element={<RegistrationSuccess />}
        />
        <Route path={"/pembayaran"} element={<FormPayment />} />
        <Route path={"/pembayaran-success/"} element={<PaymentSuccess />} />

        <Route
          path={"/soc/jadwal-pertandingan"}
          element={<JadwalPertandinganSocPage />}
        />
        {/* <Route path={"/soc/fase-knockout"} element={<FaseKnockoutSOC />} /> */}
        <Route path={"/rsvp"} element={<Rsvp />} />
      </Routes>

      {isLiveStreamingDate() && <LiveStreamingCard text={"Live Streaming"} />}
    </AppContainer>
  );
};

export default PageRoutes;
